'use server';

import { apiFetch } from '@lib/apiFetch';
import type { ForgotPassFormState } from '@auth/types';

/**
 * @description Request login link action function.
 * @param locale - The locale to use for translations.
 * @param prevState - The previous state of the reset form.
 * @param formData - The form data containing the email or phone number.
 */
export const requestLoginLinkAction = async (locale: Locale, prevState: ForgotPassFormState, formData: FormData): Promise<ForgotPassFormState> => {
  const emailOrPhone = formData.get('emailOrPhone') as string;

  const { error } = await apiFetch('/v1/openapi_login_link', {
    method: 'post',
    payload: { emailOrPhone },
    locale,
    // Do not include cookies in the request
    isClient: true,
    // The endpoint wants JSON payload, not multipart/form-data
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return error ? {
    success: false,
    type: 'request_login_link',
    errorText: error.errors?.find((err) => !err.path)?.message ?? null,
    errorData: error,
  } : {
    success: true,
    type: 'request_login_link',
    errorText: null,
  };
};
